import firebase from 'firebase'

firebase.initializeApp({
  apiKey: "AIzaSyBQZd7s7ykOZvd11KbEbbegB1JYqPXGJYk",
  authDomain: "noodle-house-3a052.firebaseapp.com",
  databaseURL: "https://noodle-house-3a052.firebaseio.com",
  projectId: "noodle-house-3a052",
  storageBucket: "",
  messagingSenderId: "77712047380",
  appId: "1:77712047380:web:0a7a1903d1227e52"
})

const database = firebase.database()

let messageId

export const getChats = () => {
  return new Promise((resolve, reject) => {
    database.ref('/messages').once('value').then(function (snapshot) {
      const messages = snapshot.val()
      messageId = messages.length

      database.ref('/chats').once('value').then(function (snapshot) {
        const chats = snapshot.val()

        database.ref('/users').once('value').then(function (snapshot) {
          const users = snapshot.val()

          const chatsResponse = chats.map(chat => {
            const lastMessageId = chat.messages[chat.messages.length - 1]
            const lastMessage = messages.find(message => {
              return message.id === lastMessageId
            })

            const partner = users.find(user => user.id === chat.partner_id)

            return {
              id: chat.id,
              partner,
              lastMessage
            }
          })

          resolve(chatsResponse)
        })
      })
    })
  })
}

export const getChatMessages = chatId => {
  return new Promise((resolve, reject) => {
    database.ref('/messages').once('value').then(function (snapshot) {
      const messages = snapshot.val()

      database.ref('/chats').once('value').then(function (snapshot) {
        const chats = snapshot.val()

        const chat = chats.find(chat => chat.id === Number(chatId))

        chat.messages = chat.messages.map(id => {
          return messages.find(message => message.id === id)
        })

        resolve(chat)
      })
    })
  })
}

export const postNewMessage = (text, chatId) => {
  return new Promise((resolve, reject) => {
    messageId++

    const newMessage = {
      id: messageId,
      user_id: 0,
      text,
      created_at: new Date().toISOString()
    }

    database.ref(`/chats/${chatId}`).once('value').then(function (snapshot) {
      const chat = snapshot.val()

      chat.messages.push(messageId)

      database.ref(`/chats/${chatId}`).set(chat).then(() => {
        database.ref(`/messages/${messageId}`).set(newMessage).then(() => {
          resolve(newMessage)
        })
      })
    })
  })
}
